var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LogOut") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,10.8L1.8,10.8C1.641,10.8 1.488,10.737 1.376,10.624C1.376,10.624 1.376,10.624 1.376,10.624C1.263,10.512 1.2,10.359 1.2,10.2C1.2,10.2 1.2,1.8 1.2,1.8C1.2,1.641 1.263,1.488 1.376,1.376C1.488,1.263 1.641,1.2 1.8,1.2C1.8,1.2 4.2,1.2 4.2,1.2C4.531,1.2 4.8,0.931 4.8,0.6C4.8,0.269 4.531,-0 4.2,-0L1.8,-0C1.323,-0 0.865,0.19 0.527,0.527C0.19,0.865 -0,1.323 -0,1.8L-0,10.2C-0,10.677 0.19,11.135 0.527,11.473C0.865,11.81 1.323,12 1.8,12C1.8,12 4.2,12 4.2,12C4.531,12 4.8,11.731 4.8,11.4C4.8,11.069 4.531,10.8 4.2,10.8ZM9.951,5.4L4.2,5.4C3.869,5.4 3.6,5.669 3.6,6C3.6,6.332 3.869,6.6 4.2,6.6L9.951,6.6C9.19,7.362 7.976,8.576 7.976,8.576C7.742,8.81 7.742,9.191 7.976,9.425C8.21,9.659 8.59,9.659 8.824,9.425L11.824,6.425C11.896,6.353 11.946,6.267 11.974,6.176L11.975,6.174C11.99,6.123 11.999,6.07 12,6.015L12,5.986C11.999,5.931 11.99,5.878 11.975,5.827L11.974,5.825C11.946,5.734 11.896,5.648 11.824,5.576L8.824,2.576C8.59,2.342 8.21,2.342 7.976,2.576C7.742,2.81 7.742,3.19 7.976,3.425L9.951,5.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.a62b31f55f8802b62ad30e479311aab7.svg";
export { ForwardRef as ReactComponent };